import Vue from 'vue';

export default {
    install(Vue) {
        Vue.$router.beforeEach(async function(to, from, next) {
            if (to.name === 'product') {
                const seoUrlParams = await getSeoUrlParams(to);
                if (!seoUrlParams) {
                    next({
                        name: 'default',
                        params: { page: to.params.product },
                        query: to.query,
                    });
                    return;
                }
                to.params.id = seoUrlParams.entity_id;
            }
            next();
        });
    },
};

const getSeoUrlParams = async to => {
    return await Vue.$store.dispatch('PageContent/getSeoUrl', {
        path: to.path,
    });
};
